import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import UnityGameDockApp from './UnityGameDockApp';

interface LeavePodiumProps {
  onLeavePodium: () => void;
  dockMode?: boolean;
}

const LeavePodium: React.FC<LeavePodiumProps> = ({ onLeavePodium, dockMode = true }) => {
  const handler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onLeavePodium();
  };

  if (dockMode) {
    return (
      <UnityGameDockApp
        ariaLabel="Leave podium — return to the audience"
        label="Leave podium"
        labelClassName="max-w-[5.75rem] whitespace-normal text-amber-100 drop-shadow-sm"
        icon={<FaArrowLeft />}
        tileClassName="bg-gradient-to-br from-orange-500 to-red-600"
        wrapperClassName="unity-leave-podium-dock"
        onClick={handler}
      />
    );
  }

  return (
    <button
      type="button"
      onClick={handler}
      className="unity-leave-podium-fallback flex items-center gap-2 rounded-lg bg-gradient-to-r from-orange-500 to-red-600 px-4 py-2.5 font-bold text-white shadow-lg transition-all duration-200 hover:brightness-110 active:scale-[0.98]"
      title="Leave podium — return to the audience"
    >
      <span className="unity-leave-podium-fallback-arrow inline-flex">
        <FaArrowLeft size={18} />
      </span>
      Leave podium
    </button>
  );
};

export default LeavePodium;
